var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymptomPrematureEjaculation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
    fill: "#613394",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55C91 72.6733 76.6733 87 59 87C41.3267 87 27 72.6733 27 55C27 37.3267 41.3267 23 59 23C76.6733 23 91 37.3267 91 55Z",
    fill: "#613394"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2872 73.1581L59.4802 67L57.3599 75.5198L59.4802 80C61.9545 80 63.9604 77.9941 63.9604 75.5198C63.9604 74.6528 63.7135 73.8439 63.2872 73.1581Z",
    fill: "#FFF9D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6733 73.1581C55.2469 73.8439 55 74.6528 55 75.5198C55 77.9941 57.0059 80 59.4802 80V67L55.6733 73.1581Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9531 36.9727C70.9531 40.4789 68.3513 43.3888 64.9766 43.8736V53.043C64.9766 54.6905 63.6358 56.0312 61.9883 56.0312H56.0117C54.3642 56.0312 53.0234 54.6905 53.0234 53.043V43.8736C49.6487 43.3888 47.0469 40.4789 47.0469 36.9727C47.0469 33.1277 50.1746 30 54.0195 30C55.9148 30 57.7004 30.7663 59 32.0978C60.2996 30.7663 62.0852 30 63.9805 30C67.8254 30 70.9531 33.1277 70.9531 36.9727Z",
    fill: "#FFBFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9531 36.9727C70.9531 40.4789 68.3513 43.3888 64.9766 43.8736V53.043C64.9766 54.6905 63.6358 56.0312 61.9883 56.0312H59V32.0978C60.2996 30.7663 62.0852 30 63.9805 30C67.8254 30 70.9531 33.1277 70.9531 36.9727Z",
    fill: "#FFA17A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9766 57.0273V58.0234C64.9766 60.9798 62.819 63.4415 59.9961 63.9163L59 59.0195L58.0039 63.9163C55.181 63.4415 53.0234 60.9798 53.0234 58.0234V57.0273C53.0234 55.3798 54.3642 54.0391 56.0117 54.0391H61.9883C63.6358 54.0391 64.9766 55.3798 64.9766 57.0273Z",
    fill: "#FF8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9766 57.0273V58.0234C64.9766 60.9798 62.819 63.4415 59.9961 63.9163L59 59.0195V54.0391H61.9883C63.6358 54.0391 64.9766 55.3798 64.9766 57.0273Z",
    fill: "#EC5569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9961 60.0156V63.9163C59.672 63.9714 59.3393 64 59 64C58.6607 64 58.328 63.9714 58.0039 63.9163V60.0156C58.0039 59.4658 58.4502 59.0195 59 59.0195C59.5498 59.0195 59.9961 59.4658 59.9961 60.0156Z",
    fill: "#EC5569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9961 60.0156V63.9163C59.672 63.9714 59.3393 64 59 64V59.0195C59.5498 59.0195 59.9961 59.4658 59.9961 60.0156Z",
    fill: "#CC2E43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(42 30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomPrematureEjaculation);
export default __webpack_public_path__ + "static/media/symptom-Premature-Ejaculation.b17e20e364725516db3671bb7712dacd.svg";
export { ForwardRef as ReactComponent };